// Copyright (c) Docugami, Inc. All rights reserved.

// eslint-disable-next-line
import Worker from 'comlink-loader!./worker'; // inline loader

export default Worker;
